(() => {
  const SetProductVariant = ($product, selected_variant_options) => {
    let current_product = window.current_product;
    if (!current_product) return;

    let product_selected_options = [...$product.querySelectorAll('[data-option-pos] input:checked')].map($input => $input.value);
    if (product_selected_options.join('|') == selected_variant_options.join('|')) return;

    let product_id = $product.dataset.product_id;
    $product.dataset.selected_variant_options = JSON.stringify(selected_variant_options);

    // console.log({selected_variant_options})
    selected_variant_options.forEach((optionValue) => {
      $product.querySelectorAll(`input[value="${ optionValue }"]`).forEach(($input) => {
        if (!$input || $input.checked) return;

        $input.checked = true;
      });

      // matte checkbox
      if (optionValue == 'Ja' || optionValue == 'Nein') {
        let $input = $product.querySelector(`input[data-index=option2][value="${ optionValue == 'Ja' ? true : false }"]`);
        if (!$input || $input.checked) return;
  
        $input.checked = true;
      }
    });

    if (current_product && current_product.id == product_id) {
      // console.log(current_product.id, product_id)
      $product.querySelectorAll('input:checked').forEach(($input, index) => {
        setTimeout(() => {
          $input.dispatchEvent(new Event('change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('trigger-variant-price-change'));
        }, index * 10);
      });
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductMain', () => ({
      current_product: null,
      products: [],
      init() {
        this.InitWatchers();
        this.InitSelf();
      },
      InitWatchers() {
        let am = this;
        document.addEventListener('variantChange', (e) => {
          if (!e.detail.variant) return;
          window.selected_options = [...e.detail.variant.options];
          let selected_variant = window.current_product.variants.find(v => v.options.join('|') == e.detail.variant.options.join('|'));
          window.current_product.selected_variant = selected_variant;
          
          (async() => {
            let cart = await GetCartJS();
            let attribute_selected_size = cart.attributes['pf_opt_gre'];
            let selected_size = selected_variant.options[0];
            if (selected_size !== attribute_selected_size) {
              let update_attr = {};
              update_attr['pf_opt_gre'] = selected_size;
              await UpdateCartAttribute(update_attr);
            }    
          })();
        });


        am.$watch('current_product', () => {
          ConvertStringToJS(this.$el.querySelector(`#product-json[data-product-id="${ this.current_product.id }"]`).innerHTML);
          let selected_options = window.selected_options || [];

          if (theme.settings.enable_pdp_discount) {
            // console.log(product.tags);
            [1,2,3].forEach((i) => {
              let discount_id = `pdp_discount_${i}`;
              let tag = theme.settings[discount_id][0];
              let percent = theme.settings[discount_id][1];
              if (product.tags.includes(tag)) {
                // console.log(tag, percent)
                let variants = [...product.variants];
                variants.forEach((variant) => {
                  let price_off = variant.price * (percent / 100);
                  variant.compare_at_price = variant.price;
                  variant.price = variant.price - price_off;
                });
                product.variants = [...variants];
              }
            });
          }
          let selected_variant = product.variants.find(v => v.options.join('|') == selected_options.join('|'));
          product.selected_variant = selected_variant;
          window.current_product = product;
          SetProductVariant(this.$el.querySelector('.product-section'), selected_options);
          document.dispatchEvent(new CustomEvent('product:changed'));
          document.dispatchEvent(new CustomEvent('trigger-variant-price-change'));
          document.dispatchEvent(new CustomEvent('check-variant-sale'));
          setTimeout(() => {
            this.$el.closest('.product-main').classList.add('loaded');
          }, 100);
          this.UpdateUrlHistory();
        });

        // update variant price
        document.addEventListener('trigger-variant-price-change', () => {
          $('.product-section').trigger({
            type: `variantPriceChange`,
            variant: window.current_product.selected_variant
          });
        });
      },
      InitSelf() {
        let $main = this.$el.querySelector('template[data-product]');
        let current_product = JSON.parse($main.dataset.product);
        window.selected_options = JSON.parse($main.dataset.selected_options);
        this.SetCurrentProduct(current_product);

        this.products = [...this.$el.querySelectorAll('template[data-product]')].map($item => JSON.parse($item.dataset.product));
      },
      SetCurrentProduct(product) {
        if (!product || (this.current_product && product.id == this.current_product.id)) return;
        this.current_product = {...product};
      },
      UpdateUrlHistory() {
        let am = this;
        if (document.querySelector('.template-collection')) return;
        let variant_id = document.querySelector('.product-section:not(.hide-product)').dataset.selected_variant_id;
        let url_params = new URLSearchParams(window.location.search);
        url_params.set('variant', variant_id);
        let newurl = `${ window.location.protocol }//${ window.location.host }/products/${ am.current_product.handle }`;
        if (url_params.toString() != '') { 
          newurl += `?${ url_params.toString() }`
        }
        window.history.replaceState({ path: newurl }, '', newurl);
      },
      e_SwitchProduct(e) {
        let product_handle = e.currentTarget.dataset.product_handle;
        if (window.current_product && window.current_product.handle == product_handle) return;
        let current_product = this.products.find(product => product.handle == product_handle);
        document.querySelectorAll('paypal-info').forEach($paypal => {
          $paypal.classList.add('b-loading');
        });
        this.$el.closest('.product-main').classList.remove('loaded');
        this.SetCurrentProduct(current_product);
      }
    }));
  });  
})();
